<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-15 16:57:47
 * @LastEditors: Merlin
 * @LastEditTime: 2025-02-24 14:22:05
 * @Description: 目前仅用于 Waves 游戏 
-->

<template>
    <div class="one-row"
        :class="{
            [isRanking ? 'ranking-row' : 'public-row']: true, 
        }"
    >
        <div class="row-left" >
            <!-- ↓ 排名 -->
            <div v-if="isRanking">
                <div class="ranking-cell">
                    <img
                        v-if="history['place'] <= 3"
                        :src="rankingImgs[history['place']]"
                        class="w-full"
                    />
                    <span v-else class="ranking-place">
                        {{ `No. ${history['place'] || ''}` }}
                    </span>
                </div>
            </div>
            <!-- ↓ 押注（币种图标） -->
            <div
                :is-show-mobile="!isRanking"
            >
                <span class="flex flex-nowrap cursor-pointer"
                    @click="jump(history.pairCurrency)"
                >
                    <CurrentCoin
                        class="w-[20px]"
                        :name="history.pairCurrency" 
                    ></CurrentCoin>
                    <IconSvgUse
                        size="20px"
                        class="up-down-icon shrink-0"
                        :use="history.oTypeColor.icon02"
                        :style="{ color: history.oTypeColor.color }"
                    />
                </span>
            </div>
            <!-- ↓ 用户 --> 
            <!-- <div class="user-box"
                @click="onUserOpenModalClick"
            >
                <UserAvatar
                    class="avatar"
                    size="30px"
                />
                <span class="user-name ellipsis flex-1">
                    {{ history.name }}
                </span>
            </div> -->
        </div>
        <!-- 
            左右分界 
        -->
        <div class="row-right"
            @click="openDetailModal"
        >
            <!-- ↓ 总押注 -->
            <div >
                <span class="gray-title">
                    <CurrentCoin
                        size="16px"
                        class="mr-1"
                        :name="history.currency"
                    />
                    {{ $t('waves.calc_WagerAmount') }}
                </span>
                <span >
                    <WavesValue
                        :number-value="history.wager" 
                        :coinName="history.currency" 
                        :iTailLong="history.iDecimalPlaces"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 倍数 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.Multiplier') }} 
                </span>
                <span >
                    x{{ Math.round(history.multi) }} 
                </span>
            </div>
            <!-- ↓ P&L, ROI -->
            <div class="pnl-wrap">
                <span class="gray-title">
                    {{ $t('waves.calc_PL_ROI') }}
                </span>
                <span class="word-warp pnl-cell"> 
                    <em v-if="history.pnl"
                        :style="{ color: history.oPNLColor.color }"
                    >
                        <WavesValue
                            :offsetDistance="'5px'"
                            :number-value="history.pnl" 
                            :coinName="history.currency" 
                            :iTailLong="history.iDecimalPlaces"
                        ></WavesValue>
                        (<WavesValue
                            :suffix="'%'"
                            :offsetDistance="'0px'"
                            :number-value="history.roi"  
                        >
                            <span style="color: var(--Background-Secondary)">
                                ROI
                            </span>
                        </WavesValue>)
                    </em>
                    <template v-else>
                        -
                    </template>
                </span>
            </div>
            <!--
                第一二行分界
            -->
            <!-- ↓ 入场价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_EntryPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.entryPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 爆仓价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_BustPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.bustPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 出场价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_ExitPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.exitPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import p01 from '@/assets/imgs/ranking/place-1.webp';
import p02 from '@/assets/imgs/ranking/place-2.webp';
import p03 from '@/assets/imgs/ranking/place-3.webp';
// --- ↑ 图 --------------------------------------------------- 
import WavesValue from '@/pages/casino/futuresGame/_components/wavesValue.vue';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import type { WavesHistoryPlus } from '@/socket/game/dto/waves.dto';
import { 
    jump2TargetCoin,
} from '@/pages/casino/futuresGame/ts/wavesFn'; 
import { 
    fnSettingCenter_Ft, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 


const props = defineProps({
    history: {
        type: Object as PropType<WavesHistoryPlus>, 
        default: () => ({}),
    },
    tabName: {
        type: String as PropType<HistoryTabsEnum>, 
    },
    // ↓ 以下各项需要声明出来，否则控制台一直打印 warn 信息 
    isMobileMode: Boolean, 
    showSharingDialog: Function, 
    userModalControl: Function, // 同上 
    seeRoundDetail: Function, // 加上，防止在首页显示时控制台打印示警信息 
});

const rankingImgs = ['', p01, p02, p03];
const oSettingCenter = fnSettingCenter_Ft(); 
const emit = defineEmits(['dialogControl','openGameDetail']);

const { coin } = useFuturesStore()
// ↓ 在排行页的标记 
const isRanking = computed(()=>{
    const bResult = (
        props.tabName === HistoryTabsEnum.leaderboard
    );
    return bResult;
});

const openDetailModal = () => {
    const type = (
        isRanking.value
        ? HistoryTabsEnum.leaderboard
        : HistoryTabsEnum.public
    );
    //  ↓ 游戏详情传值
    const data = {
        data: `futures:${props.history._id}`,
        modal: 'BetDetails',
        wavesType: type,
    }
    emit('openGameDetail',data)

    // ↓ 打开游戏详情，取消跳转事件，改为直接打开游戏详情浮层
    // const {path, query={}} = useRoute();
    // useRouter().push({
    //     replace: true,
    //     path,
    //     query: {
    //         ...query,
    //         data: `futures:${props.history._id}`,
    //         modal: 'BetDetails',
    //         wavesType: type,
    //     },
    // });
};

const onUserOpenModalClick = () => {
    // ↓ 通过判断，说明当前组件在【首页】被调用 
    if (props.userModalControl){
        props.userModalControl(props.history.userId);
        return;
    }
    const user = {
        visible: true,
    };
    emit('dialogControl', {user });
};


const jump = (value) => {
    if (coin.includes(value.toLocaleUpperCase())) {
        jump2TargetCoin(value)
    } else {
        showNegativeNotify({
            i18n: 'waves.notExist',
            position: 'top', // 在顶部弹出，防止侵入用户操作  
            type: 'warning',
            timeout: 1 * 1_000, // 驻留时长 ms
            actions: [],
        })
    }
}
</script>

<style scoped lang="scss" src="./style/wavesTable.scss"></style>
<style scoped lang="scss">


.bold-row{
    .gray-title,
    .ranking-place{
        color: rgba(255,255,255, 0.6);
    }
    .pnl-cell *{
        color: white !important;
    }
}


.wave-amount{
    display: block;
    margin: auto 0;
    overflow-x: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 14px;
}


.ranking-cell{
    width: 32px;
    font-size: 14px;
    color: rgb(147, 172, 211);
    text-align: left;
    white-space: nowrap;
    position: absolute;
    top: 0px;
    left: 0px;
}

</style>
